import PropTypes from 'prop-types';
import { deprecatedPropValues } from '../core/deprecated-prop-values.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

const propTypes = {
    /**
   * Visual style of the StandardTile.
   * Available options: "standard", "product", "gallery", "circular"
   *
   * The 'gallery' skin is deprecated - use the standard skin instead
   */ skin: deprecatedPropValues(PropTypes.oneOf([
        'standard',
        'product',
        'gallery',
        'circular'
    ]), [
        'gallery'
    ], 'Omit or use the `standard` skin instead'),
    /**
   * Specifies whether the tile is vertically or horizontally oriented
   * Available options: "vertical", "horizontal"
   */ layout: PropTypes.oneOf([
        'vertical',
        'horizontal'
    ]),
    /**
   * The tile background
   * Available options: "standard", "translucent"
   */ background: PropTypes.oneOf([
        'standard',
        'translucent'
    ]),
    /**
   * Width setting for the image on the tile
   * Available options: "standard", "full-bleed"
   */ imageWidth: PropTypes.oneOf([
        'standard',
        'full-bleed'
    ]),
    /**
   * Specifies if the image shadow should have a shadow
   * @deprecated This prop was only used by the "gallery" skin, which has also been deprecated.
   */ imageShadow: deprecatedProp(PropTypes.bool, 'This prop was only used for the "gallery" skin, which has also been deprecated')
};
const StandardTile = createComponent({
    displayName: 'StandardTile',
    root: 'div',
    propTypes,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.standardTile,
    propConfig: {
        classNames ({ skin, layout, background, imageWidth, imageShadow }) {
            const classesSet = new Set([
                'swan-standard-tile'
            ]);
            if (skin !== 'standard') classesSet.add(`swan-standard-tile-skin-${skin}`);
            if (layout === 'horizontal') classesSet.add('swan-standard-tile-horizontal');
            if (background === 'translucent' && skin === 'gallery') classesSet.add('swan-standard-tile-background-translucent');
            if (imageWidth === 'full-bleed' && skin === 'product') classesSet.add('swan-standard-tile-full-bleed');
            if (imageShadow === false && skin === 'gallery') classesSet.add('swan-standard-tile-hide-image-shadow');
            return classesSet;
        }
    }
});
StandardTile.defaultProps = {
    skin: 'standard',
    layout: 'vertical',
    imageWidth: 'standard'
};

export { StandardTile };
